const LOC = localStorage.getItem("lang") === "en" ? "en-GB" : "it-IT";
export const EUR = new Intl.NumberFormat(LOC, {
  style: "currency", currency: "EUR", maximumFractionDigits: 0,
});
export const EUR2 = new Intl.NumberFormat(LOC, {
  style: "currency", currency: "EUR", minimumFractionDigits: 2,
});
export const DATE_IT = new Intl.DateTimeFormat(LOC, {
  day: "2-digit", month: "short", year: "numeric",
});
export function fmtDate(s) {
  if (!s) return "—";
  try { return DATE_IT.format(new Date(s)); } catch { return s; }
}
export function fmtDateShort(s) {
  if (!s) return "—";
  const [y, m, d] = String(s).slice(0, 10).split("-");
  return d ? `${d}/${m}/${y.slice(2)}` : s;
}
export function fmtTimeRange(start, end) {
  if (!start) return "";
  return end ? `${start}–${end}` : start;
}
export const DATE_TIME_IT = new Intl.DateTimeFormat(LOC, {
  day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
});
export function fmtDateTime(s) {
  if (!s) return "—";
  try { return DATE_TIME_IT.format(new Date(s)); } catch { return s; }
}
export function donorName(d) {
  if (!d) return "—";
  const isOrg = ["chiesa","azienda","associazione","fondazione"].includes(d.type);
  if (isOrg && d.org_name) {
    return d.referente ? `${d.org_name} — ${d.referente}` : d.org_name;
  }
  return d.org_name || `${d.first_name || ""} ${d.last_name || ""}`.trim() || "—";
}
export function initials(d) {
  const n = donorName(d);
  return n.split(" ").filter(Boolean).slice(0, 2).map(x => x[0]).join("").toUpperCase() || "•";
}
